export interface RuntimeNetworkPolicy {
  id: string;
  version: string;
  outboundConnections: 'none';
  birthDataLeavesDevice: false;
  analytics: false;
  advertising: false;
  aiRuntime: false;
  externalFonts: false;
  externalImages: false;
  disclosure: string;
}

export const DEFAULT_RUNTIME_NETWORK_POLICY: RuntimeNetworkPolicy = Object.freeze({
  id: 'NETWORK-LOCAL-ONLY',
  version: '1.0.0',
  outboundConnections: 'none',
  birthDataLeavesDevice: false,
  analytics: false,
  advertising: false,
  aiRuntime: false,
  externalFonts: false,
  externalImages: false,
  disclosure: '正式核心模式不建立執行期對外連線；出生資料、命盤、解讀與本機備份都留在使用者裝置。',
});

export const DEFAULT_CONTENT_SECURITY_POLICY = [
  "default-src 'self'",
  "base-uri 'self'",
  "object-src 'none'",
  "frame-ancestors 'none'",
  "frame-src 'none'",
  "form-action 'none'",
  "script-src 'self'",
  "style-src 'self'",
  "img-src 'self' data: blob:",
  "font-src 'self'",
  "connect-src 'none'",
  "worker-src 'self' blob:",
  "manifest-src 'self'",
  "media-src 'none'",
].join('; ');

export interface SecurityHeader {
  name: string;
  value: string;
}

export const DEFAULT_SECURITY_HEADERS: readonly SecurityHeader[] = Object.freeze([
  Object.freeze({ name: 'Content-Security-Policy', value: DEFAULT_CONTENT_SECURITY_POLICY }),
  Object.freeze({ name: 'Referrer-Policy', value: 'no-referrer' }),
  Object.freeze({ name: 'X-Content-Type-Options', value: 'nosniff' }),
  Object.freeze({ name: 'X-Frame-Options', value: 'DENY' }),
  Object.freeze({ name: 'Cross-Origin-Opener-Policy', value: 'same-origin' }),
  Object.freeze({ name: 'Cross-Origin-Resource-Policy', value: 'same-origin' }),
  Object.freeze({ name: 'Permissions-Policy', value: 'geolocation=(), camera=(), microphone=(), payment=(), usb=(), browsing-topics=()' }),
]);

export function assertRuntimeNetworkPolicy(policy: RuntimeNetworkPolicy = DEFAULT_RUNTIME_NETWORK_POLICY): void {
  if (policy.outboundConnections !== 'none') throw new Error('Core runtime network policy must deny outbound connections');
  for (const [key, value] of Object.entries(policy)) {
    if (['analytics', 'advertising', 'aiRuntime', 'externalFonts', 'externalImages', 'birthDataLeavesDevice'].includes(key) && value !== false) {
      throw new Error(`Core runtime network policy must keep ${key} disabled`);
    }
  }
}

export function renderCloudflarePagesHeaders(headers: readonly SecurityHeader[] = DEFAULT_SECURITY_HEADERS): string {
  const duplicateNames = headers.map((header) => header.name.toLowerCase()).filter((name, index, all) => all.indexOf(name) !== index);
  if (duplicateNames.length) throw new Error(`Duplicate security header: ${duplicateNames[0]}`);
  return `/*\n${headers.map((header) => `  ${header.name}: ${header.value}`).join('\n')}\n`;
}
